module.exports = __webpack_public_path__ + "img/cake.d74e3e8d.png";